import { PropsWithChildren } from "react";

import { ValueType } from "@ryde/shared";

export const FILTER_CONST = {
  DROPDOWN_AREA_WIDTH: 250,
  SEARCH_CONTROL_TOP: 8,
  SEARCH_CONTROL_HEIGHT: 40,
  SCROLLABLE_AREA_TOP_OFFSET: 49,
  LIST_ITEM_HEIGHT: 40,
  LIST_ITEM_WIDTH: "100%",
  OVERSCAN_COUNT: 10,
} as const;

export interface IFilterMultiProps extends PropsWithChildren {
  customFieldId: number;
  initialCheckedValues?: ValueType;
  isServerSearch?: boolean;
}
